import { render, staticRenderFns } from "./DocumentoItem.vue?vue&type=template&id=b812cd26&scoped=true&"
import script from "./DocumentoItem.vue?vue&type=script&lang=js&"
export * from "./DocumentoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b812cd26",
  null
  
)

export default component.exports